import EndUsersAccountsTable from './tables';
import useToast from '@fuse/hooks/useToast'
import FusePageCarded from '@fuse/core/FusePageCarded';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useRouter from '@fuse/hooks/useRouter';
import reducer from '../store';
import withReducer from 'app/store/withReducer';
import { usePermission, usePusher } from '@fuse/hooks';
import useCurrentUser from '@fuse/hooks/useCurrentUser';


const useStyles = makeStyles({
	layoutRoot: {
		background:'#fcfcfc'
	},
	pullRight:{
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end"
	},
	buttonContainer:{
		display: 'flex',
		flexDirection: 'row'
	},
	buttonSquare:{
		borderRadius: '5px'
	},
	topBg:{
		background:'#fcfcfc'
	},
	contentWrapper : {
		marginBottom:'15px',
		borderRadius:'10px'
	}
});

function CardedFullWidth2TabbedSample(props) {
	const router = useRouter();
	const classes = useStyles();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const [page, setPage] = useState(0);
	const { hasPermission } = usePermission();
	const viewServiceRequestPermission = hasPermission('view-service_request')
	const createServiceRequestPermission = hasPermission('add-service_request')
	const updateServiceRequestPermission = hasPermission('update-service_request')
	const deleteServiceRequestPermission = hasPermission('delete-service_request')
	const [loading, setLoading] = useState(false);
	const {broadcastChannel} = usePusher()
	const new_incident_event = "permission_change"
	const user = useCurrentUser();
	const [selectedTab, setSelectedTab] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [totalRecords, setTotalRecords] = useState(0);

	/* function getServiceRequest(){
		axios.get(`/service/show-all-service-request?archived=${true}`).then((res) => {
			const { response } = res.data.data;
			setServiceRequest(formatData(response))
			setTotalRecords(response?.length)
		}).catch((err) => {
			console.log(err)
		}).finally(() => {
			setLoading(false)
		});
	}

	function formatData(data){
		const serviceReqWithUnreadMessage = [], serviceRequests = []
		for( let item of data){
			const formattedObject = {
				id: item?.id,
				ticket_number: item?.ticket_id,
				asset_id: item.asset_id,
				serial_number: item?.asset?.serial_number ?? 'No Serial Number',
				problem_summary: item?.title,
				priority: item?.service_request_priority?.name,
				model_number: item?.asset?.asset_model?.model_no,
				// model_name: item?.asset?.asset_model?.model_name,
				contract_Number: item?.asset?.contract_header?.entity_external_platform_id,
				status: item?.service_request_status?.status_name,
				status_details: {
					id: item?.service_request_status?.id,
					status_name: item?.service_request_status?.status_name,
					status_color: item?.service_request_status?.status_color
				},
				priority_details: {
					id: item?.service_request_status?.id,
					priority_name: item?.service_request_priority?.name,
					priority_color: item?.service_request_priority?.priority_color
				},
				// category_name: item?.service_request_category?.category_name,
				// source_name: item?.service_request_source?.source_name,
				agent_name: item.agent ? `${item.agent.first_name} ${item.agent.last_name}(${item.agent.email})` : 'Unassigned',
				agent_details: {
					id: item.agent?.id,
					first_name: item.agent?.first_name || '',
					last_name: item.agent?.last_name || '',
				},
				user_name: item.requestor ? `${item.requestor.first_name} ${item.requestor.last_name}(${item.requestor.email})` : 'Unassigned',
				user_details: {
					id: item.asset?.assigned_user?.id,
					first_name: item.asset?.assigned_user?.first_name || '',
					last_name: item.asset?.assigned_user?.last_name || '',
				},
				client_name: item.user_company.company_name,
				asset_name: item.asset?.asset_name ?? 'N/A',
				location: generateProperLocationString({
					location_name: item.asset?.shipping?.location_name ?? '',
					address1: item.asset?.shipping?.address1 ?? '',
					address2: item.asset?.shipping?.address2 ?? '',
					city: item.asset?.shipping?.city ?? '',
					state: item.asset?.shipping?.state ?? '',
					country: item.asset?.shipping?.country ?? '',
					zip:  item.asset?.shipping?.zip ?? ''
				}),
				shipping_location_details: {
					id: item.asset?.shipping?.id,
					location_name: item.asset?.shipping?.location_name,
					address1: item.asset?.shipping?.address1 || '',
					city: item?.asset?.shipping?.city || '',
					state: item?.asset?.shipping?.state || '',
					country: item?.asset?.shipping?.country || '',
				},
				detailed_description_of_the_issue: stripHtml(item?.description),
				created_date: item.created_at ? getLocalTimeFromUTC(item.created_at) : '-',
				updated_date: item.updated_at ? getLocalTimeFromUTC(item.updated_at) : '-',
				has_unread_message: item.new_message_to_agent
			}
			if(formattedObject.has_unread_message){
				serviceReqWithUnreadMessage.push(formattedObject)
			}else{
				serviceRequests.push(formattedObject)
			}
		}
		return [...serviceReqWithUnreadMessage, ...serviceRequests]
	}

	const handleTabChange = (event, value) => {
		setSelectedTab(value);
	};

	useEffect(()=>{
		setLoading(true)
		getServiceRequest()

		if(serial_number){
			dispatch(openFormViewerDialog())
		}

		//call on component unmount
		return(()=>{
			dispatch(setSerialNumberForServiceRequest(null))
			dispatch(closeFormViewerDialog())
		})
	},[]);*/

	useEffect(()=>{
		if(broadcastChannel/* && invoices.length*/){
			broadcastChannel.bind(new_incident_event, data => {
				if(data.user_companies_id == user.data.user_companies_id){
					location.reload();
				}
			})
			return () => broadcastChannel.unbind(new_incident_event)
		}
	},[broadcastChannel])

	return (
		<div>
			<FusePageCarded
				classes={{
					root: classes.layoutRoot,
					toolbar: 'p-0',
					topBg: classes.topBg,
					contentWrapper : classes.contentWrapper
				}}
				content={
					<>
						<div className={selectedTab !== 0 ? 'hidden' : ''}>
							<EndUsersAccountsTable
								totalRecords={totalRecords}
								page={page}
								setPage={setPage}
								rowsPerPage={rowsPerPage}
								setRowsPerPage={setRowsPerPage}
								loading={loading}
								viewServiceRequestPermission = {viewServiceRequestPermission}
								createServiceRequestPermission = {createServiceRequestPermission}
								updateServiceRequestPermission = {updateServiceRequestPermission}
								deleteServiceRequestPermission = {deleteServiceRequestPermission}
							/>
						</div>
					</>
				}
				innerScroll
			/>
		</div>
	)
}

export default withReducer('ArchivedServiceRequestsApp', reducer)(CardedFullWidth2TabbedSample);
